// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import SeatAction from './data'

export default function SeatActionFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/SeatAction">
      <SeatAction {...props}>
        {children}
      </SeatAction>
    </Flow>
  )
}
